import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from "@/config/bwmodel";
import h5Share from "@/utils/h5Share";
import {Toast} from 'antd-mobile'
import { jumpTo, } from "@/utils";
// import Tabs from '@/components/Tabs'
import styles from "@/styles";
import { handleUploadTrace } from "../activity_30/stock";
import { fetchKolList, fetchKolVote, fetchKolSearch } from "./api";
import CloseBtn from './images/close@2x.png'
import ModalView from '@/components/modal-view'
import bridge from '@/config/JSbridge'
import { connect } from 'react-redux';
import OpenApp from '../../components/OpenApp';

export const isStorm = bwmodel.app === "storm";
const CarnivalGame = ({token}) => {
  const [kolList, setKolList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [showExplain,setShowExplain] = useState(false);
  // const [rankType, setRankType] = useState(false);
    // 模拟搜索 API
  const mockSearchAPI = async (query) => {
     
    return new Promise(resolve => {
    
      const params = {
        keywords: searchTerm,
      }
      fetchKolSearch(params)
        .then(res => {
          resolve(res.kolList);
        })
     
    });
  };

    
  // 防抖函数
  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      
      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    
    return debouncedValue;
  };
  
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
    // 搜索逻辑
  useEffect(() => {
    if (debouncedSearchTerm) {
      // setLoading(true);
      setShowResults(true);
      mockSearchAPI(debouncedSearchTerm).then(data => {

        if(data ) {
          
          if(data.length>0) {
             setResults(data);
          }  else {
            setResults([]);
          }
          // 存在本地
         
        } else {
           setResults([]);
        }
      });
      
    } else {
      setShowResults(false);
      setResults([]);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getList();
    h5Share.main({
      title: `邀您参与2025年度社区影响力评选`,
      desc: "谁是你心目中的牛人！为他投上一票",
      link: process.env.REACT_APP_DEMAND_URL + "active_209",
      thumbUrl: "https://file.wogoo.com/app/logo/logo6.png",
      wxShare: {
        shareData: {
          imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
        },
      },
      shareData: {
        imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
      },
    });
    // 埋点
    if (isStorm) {
      handleUploadTrace("7th-anniversary", "visitor");
    } else {
      handleUploadTrace("7th-anniversary_outside", "visitor");
    }
    //
  }, []);
  // useEffect(() => { 
 
  // }, []);
  function getList() {
      const  search_id = localStorage.getItem('active_209_search_id');
    fetchKolList({
      param: search_id||''
    })
      .then((res) => { 
        const kolList = res.kolList;
        const recentSearchKol = res.recentSearchKol;
        // const  search_id = localStorage.getItem('active_209_search_id');
        const result = kolList.filter(item => item.userId === search_id)
        if(search_id && result[0]) {
         
         const result =  moveToFirstById(kolList, search_id)
         setKolList(result)
          
        } else if(recentSearchKol && recentSearchKol.userId){
          kolList.unshift(recentSearchKol);
          kolList.length = kolList.length - 1; // 或 arr.pop()
            setKolList(kolList)
        } else {
          setKolList(kolList)        
        }
       
      });
  }
 
  function moveToFirstById(arr, userId) {
  const index = arr.findIndex(item => item.userId === userId);
  if (index > 0) {
    const [item] = arr.splice(index, 1);
    arr.unshift(item);
  }
  return arr;
}

const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

 const linkToDownload = () => {
    // 埋点
   
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }
   function handleKolVote(item, type) {
  if (!isStorm) {
      linkToDownload()
      return
    }
    if(!token) {
      return handleLogin();
    }
    
    const params = {
      param: item.userId
    }
   
    fetchKolVote(params)
      .then((res) => { 
        if(res.data === "2") {
          Toast.info('今日投票还剩2次');
        } else if(res.data === "1") {
          Toast.info('今日投票还剩1次');
        } else {
          Toast.info('今日投票已用完');
        }
         
         if(type ) {
            localStorage.setItem('active_209_search_id', item.userId);
            setShowResults(false);
            setResults([]);
            setSearchTerm('')
          }
         getList();
      })
      .catch((err) => {
        Toast.info(err.response.data.errors[0].message);
        console.log(err.response.data.errors[0].message);
      });
  } 
  return ( 
    <div>
      {isStorm && (
        <Header
          title="2025年度社区影响力牛人评选"
          hideNaviBar
          bg_color={styles.bg_color2}
          right={<img onClick={ () => {

              bridge.callHandler('nativeEvent', {
                event: 'shareLink',
                params: {
                  title: `邀您参与2025年度社区影响力评选`,
                  desc: '谁是你心目中的牛人！为他投上一票',
                  thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                  linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_209',
                }
              })
            }
          } 
          src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
        />
      )}
      <Content>

        <DescIcon
                style={{marginTop:'60px'}}
                onClick={() => {
                  setShowExplain(true)
                }}
                alt='市值风云'
              >
                  活<br/>动<br/>规<br/>则
                </DescIcon>
        <img src={require("./images/Slice6@2x.png")} alt="" />
      

         <div style={{ marginBottom: '20px', padding: '0 20px' }}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="请输入候选人昵称"
              style={{
                padding: '8px 15px',
                fontSize: '16px',
                width: '100%',
                boxSizing: 'border-box',
                border: '1px solid #865E35',
                borderRadius: '12px',
                backgroundColor: '#180601',
                color: '#fff',
              }}
            />
          </div>
      
        <img className='img_title' src={require("./images/参与投票@2x.png")} alt="" />
        <div className="title_box">
          {/* <div className="title_left">
            默认按候选人注册时间排列
          </div> */}
        </div>
        {
        showResults &&   results && results.length>=0 &&   results.map(item =>  <UserCard key={item.userId}>
              <img
                className="user-img"
                src={item.avatar}
                alt=""
                onClick={
                  () => jumpTo(`storm://app/userzone?userID=${item.userId}&userName=${item.nickname}`)
                }
              />
              <div className="user-info">
                <div className="user-name">{item.nickname} </div>
               
               {
                  item.userTitleList && item.userTitleList.length > 0 ?  (<div >{item.userTitleList[0].titleText}</div>):<div>{item.introduce}</div>
                }
              </div>
              <div className="user-right">
                <div className="user-btn" onClick={()=>{handleKolVote(item, 'search')}}>
                    <img src={require("./images/Group_1597880706@2x.png")} alt="" />
                </div>
                <div className="user-num"> <span>{item.voteCount} </span>票</div>
              </div>
            </UserCard>
           )
        }

        {
        !showResults && kolList.map((item, index) => { 
            return <UserCard key={index}>
              <img
                className="user-img"
                src={item.avatar}
                alt=""
                onClick={
                () => jumpTo(`storm://app/userzone?userID=${item.userId}&userName=${item.nickname}`)
                }
              />
              <div className="user-info">
                <div className="user-name">{item.nickname} </div>
               
                {
                  item.userTitleList && item.userTitleList.length > 0 ?  (<div >{item.userTitleList[0].titleText}</div>):<div>{item.introduce}</div>
                }
                
              </div>
              <div className="user-right">
                <div className="user-btn" onClick={()=>{handleKolVote(item)}}>
                    <img src={require("./images/Group_1597880706@2x.png")} alt="" />
                </div>
                <div className="user-num"> <span>{item.voteCount} </span>票</div>
              </div>
            </UserCard>
          })
        }
      {
        !showResults && <img src={require("./images/Slice11@2x.png")} alt="" />
      }
      </Content>
       <ModalView
              visible={showExplain}
              onClose={() => setShowExplain(false)}
              onOverlayClick={() => setShowExplain(false)}
              content={
                <ModalContent >
                  <div className="explain-card-wrap">
                    <div className="explain-wrap">
                      <div className="explain-card">
                           <img src={require("./images/rules@2x.png")} alt=""  className="explain-img" />
                        {/* <img src={"./images/rules@2x.png"} alt='' className="explain-img" /> */}
                      </div>
                      <div className="explain-close">
                           {/* <img src={require("./images/Group_1597880706@2x.png")} alt="" /> */}
                {/* </div> */}
                        <img onClick={() => setShowExplain(false)} className="close-btn" src={CloseBtn} alt=""/>
                      </div>
                    </div>
                  </div>
                </ModalContent>
              }
            />
            {
              !isStorm && <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_209`}></OpenApp>
            }
    </div>
  );
};


const mapStateToProps = (state) => ({
  token: state.user.accessToken 
});
export default React.memo(connect(mapStateToProps)(CarnivalGame))

// export default CarnivalGame;

const Content = styled.div`
  width: 100%;
  min-height: calc(100vh);
  background: #180601;
  border-radius: 0px 0px 0px 0px;
  img {
    max-width: 100%;
  }
  .title_left {

    font-family: OPPO Sans 4.0, OPPO Sans 40;
    font-weight: 400;
    font-size: 12px;
    color: #FFD174;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .img_title {
    margin: auto;
    display: block;
    text-align: center;
    height: 16px;
  }
  .title_box {
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      height: 15px;
    }
    
  }
`;
const ModalContent = styled.div`
  width: 60%;
  img {
    max-width: 100%;
  }
  .explain-close {
  margin-top 20px;
  text-align: center;
    img {
    
      width: 20px;
    }
  }
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // .modal-title {
  //   font-size: 16px;
  //   color: #FFFFFF;
  //   line-height: 20px;
  //   text-align: center;
  //   font-style: normal;
  //   text-transform: none;
  //   margin-bottom: 16px;
  // }
 `
const UserCard = styled.div`
  // width: 100%;
  margin: 20px 16px;
  padding: 16px 14px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #472b10 0%, rgba(46, 27, 9, 0) 100%);
  // background: #fff;
  border-radius: 67px 67px 67px 67px;
  display: flex;
  align-items: center;
  .user-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #ffffff;
  }
  .user-info {
    margin-left: 16px;
    font-weight: 400;
    font-size: 11px;
    color: #d29b60;
    align-self: start;
    width: 50%;
    flex: 1;
  }
  .user-name {
  width: 100%;
    font-family: OPPO Sans 4, OPPO Sans 40;
    font-weight: 600;
    font-size: 16px;
    color: #fff3dc;
    line-height: 26px;
     white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; 
    margin-bottom: 8px;
  }
  .user-btn {
    width: 75px;
  }
  .user-num {
    margin-top: 4px;
    text-align: center;
    font-size: 10px;
    color: #FFCF6D;
    span {
      color: #FFF3DC;
    }
  }
`;


 const DescIcon = styled.div`
    width: 22px;
    height: 58px;
    background: #4B280A;
    border-radius: 5px 0px 0px 5px;
    font-size: 11px;
    opacity: 0.95;
    z-index:2;
    text-align:right;
    background-position: right center;
    background-repeat: no-repeat;
    position: absolute;
    top: 48px;
    right: 0;
    color: #DFC03D;
    display:flex;
    justify-content: center;
    align-items: center;
`
// const ExplainCard = styled.div`
//   img {
//   src: url
//   }
//   &.award   .explain-card-wrap  {
//     .explain-wrap {
//       background-image: url(${bgModal});
//       background-repeat: no-repeat;
//       background-size: contain;
//       // height: calc(80vh - 100px);
//       // height:  calc(392px + 100px);
//       width: 272px;
//       // width: 372px;
//       height: 370px;
//     }
//   }
//   .explain-card-wrap {
//     width: 100%;
//     box-sizing: border-box;
//     padding: 0 20px;
//     max-width: 334px;
//     position: relative;
//     padding-bottom: 60px;
   
//     .explain-wrap {
//       height: calc(100vh - 100px);
//       .explain-card {
//         width: 100%;
//         height: 100%;
//         overflow-y: scroll;
//         .num {
//           width: 382px;
//           img {
//             width: 100%;
//           }
//         }
//         .award_text {
//           margin-top: 210px;
//           text-align: center;
//           .title {
//             color: #000000;
//             font-size: 20px;
//             line-height: 20px;
//           }
//           .name {
//             margin-top: 15px;
//             font-size: 38px;
//             font-family: Source Han Sans SC;
//             font-weight: bold;
//             color: #FF7825;
//           }
//           .description {
//             margin-top: 10px;
//             font-size: 12px;
//             font-family: Source Han Sans SC;
//             font-weight: 400;
//             color: #0E0509;
//           }
//           .btn {
//             width: 171px;
//             margin:auto;
//             margin-top: 17px;
//             >img {
//               width: 100%;
//             }
//           }
//         }
      
//         &::-webkit-scrollbar {
//           display: none;
//         }
//         &::-webkit-scrollbar {
//           display: none;
//         }
//         .explain-img {
//           width: 100%;
//         }
//         .explain-text {
//           color: #fff;
//           font-size: 30px;
//           >img {
//            width: 100%;
//           }
//         }
//       }
//       .explain-close {
//         height: 60px;
//         display: flex;
//         width: 100%;
//         justify-content: center;
//         box-sizing: border-box;
//         padding-top: 2px;
//         .close-btn {
//           width: 20px;
//           height: 20px;
//         }
//       }
//     }
//   }


//   .empty-wrap {
//     position: relative;
//     padding: 0 35px;
//     width: 100%;
//     max-width: 305px;
//     .empty-card {
//       width: 100%;
//       height: 115.75px;
//     }
//     .empty-close-btn {
//       right: 46px;
//       top: 12px;
//       width: 20px;
//       height: 20px;
//       position: absolute;
//       z-index: 5;
//     }
//   }
// `;



// WEBPACK FOOTER //
// ./src/views/activity_209/index.js